import { render, staticRenderFns } from "./LoginInterno.vue?vue&type=template&id=780c089e&scoped=true"
import script from "./LoginInterno.vue?vue&type=script&lang=ts"
export * from "./LoginInterno.vue?vue&type=script&lang=ts"
import style0 from "./LoginInterno.vue?vue&type=style&index=0&id=780c089e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780c089e",
  null
  
)

export default component.exports